(() => {
  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.formatMoney !== 'function') {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    const formatWithDelimiters = (cents, precision = 2, thousands = ',', decimal = '.') => {
      const amount = Number(cents);
      if (!Number.isFinite(amount)) return '0';
      const parts = (amount / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };

    window.Shopify.formatMoney = (cents, format) => {
      const normalizedCents = typeof cents === 'string' ? cents.replace('.', '') : cents;
      const formatString = format || '{{amount}}';
      const match = formatString.match(placeholderRegex);
      if (!match) return formatString;

      let value;
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(normalizedCents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(normalizedCents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(normalizedCents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(normalizedCents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(normalizedCents, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(normalizedCents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(normalizedCents, 0, ' ', ',');
          break;
        default:
          value = formatWithDelimiters(normalizedCents, 2);
      }
      return formatString.replace(placeholderRegex, value);
    };
  }

  if (typeof window.extractContent !== 'function') {
    window.extractContent = (html) => {
      const parsed = new window.DOMParser().parseFromString(String(html), 'text/html');
      return parsed.documentElement.textContent;
    };
  }
})();
